import { CompanyAdmin } from './../../popup/company-admin-support-popup/service/company-admin-support.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HeaderItem, MenuItem } from '../../model/header.model';
import { Response } from '@app/core/model/http.model';
import { Competency } from '@app/explore/shared/menu/skills.model';

@Injectable({
    providedIn: 'root',
})
export class HeaderHttpService {
    constructor(private httpClient: HttpClient) {}

    /**
     * Header custom items
     */
    getHeaderItems(): Observable<Array<HeaderItem>> {
        return this.httpClient.get('api/dash/menu/header').pipe(
            map((res: Response) => {
                return res.data as Array<HeaderItem>;
            }),
        );
    }

    /**
     * Header dropdown custom items
     */
    getHeaderMenuItems(): Observable<Array<MenuItem>> {
        return this.httpClient.get('api/dash/menu/hamburger/dropdown').pipe(
            map((res: Response) => {
                return res.data as Array<MenuItem>;
            }),
        );
    }

    getComapnyAdminsHttp(): Observable<CompanyAdmin[]> {
        const url = `api/help/company-admins`;

        return this.httpClient.get<Response>(url).pipe(map((data) => data.data as CompanyAdmin[]));
    }

    getAvailableSkills(): Observable<Competency[]> {
        const url = `api/v2.5/gamification/explore/available-skills`;
        return this.httpClient.get<Response>(url).pipe(map((res: Response) => res.data));
    }
}
